export class AreaEsightModel {
  public profile: any[] = [];
  public functions: [];
  public commesse: string;
  public notes: string;
}
